import { gql } from "lib/apolloClient";

export const categoryWiseAssessmentsFragment = {
  assignmentsFragment: gql`
    fragment categoryWiseAssessmentItem on AcademicCriteriaValue {
      id
      assignments(filters: $assignmentFilters) {
        id
        content {
          id
          ... on Assessment {
            id
            title {
              id
              value
            }
            weightage
            assessmentTools(filters: { assessmentToolType: SCORE }) {
              totalCount
              edges {
                node {
                  id
                  assessmentToolType
                  assessmentToolItem {
                    id
                    ... on ScoreAssessmentTool {
                      id
                      scoreToolData {
                        id
                        maxScore
                        categoryId
                      }
                    }
                  }
                }
              }
            }
          }
        }
        assignedStudents {
          id
          student {
            id
          }
        }
      }
    }
  `,
};
